import { ticks } from './config';

export interface CharacterDef {
  /** Top speed in px/s. */
  moveSpeed: number;
  /** px/s² while steering. */
  acceleration: number;
  /** px/s² when no direction is held. */
  friction: number;
  /** Movement collision circle radius (ground plane). */
  bodyRadius: number;
  /** Radius bullets hit. */
  hurtRadius: number;
  maxHp: number;
  respawnTicks: number;
}

export const GARDENER: CharacterDef = {
  moveSpeed: 92,
  acceleration: 1100,
  friction: 1400,
  bodyRadius: 5,
  hurtRadius: 6,
  /** 120 since ADR-0080 (was 100): every gun needs a fifth more to kill a gardener, so fights last longer. */
  maxHp: 120,
  respawnTicks: ticks(3),
};
